/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
    Navigate,
    Route, Routes,
} from 'react-router-dom';

import CreateOrganizationContainer from "./CreateOrganizationContainer";
import EditOrganizationContainer from "./EditOrganizationContainer";
import OrganizationsContainer from './OrganizationsContainer';
import OrganizationAddTeamMemberContainer from "./OrganizationAddTeamMemberContainer";

export default class OrganizationsRouter extends Component {
    static propTypes = {

    };

    static defaultProps = {

    };

    render() { // eslint-disable-line
        return (
            <Routes>
                <Route path="/" element={<OrganizationsContainer/>} />
                <Route path="/create-organization" element={<CreateOrganizationContainer/>} />
                <Route path="/:id/managed-organizations" element={<EditOrganizationContainer/>} />
                <Route path="/:id/organization-add-team-member" element={<OrganizationAddTeamMemberContainer/>} />
            </Routes>
        );
    }
}
